import React, { useContext, useEffect, useState } from 'react'
import {
    Container,
    FiltersDiv,
    FiltersText
} from './style'

interface DropdownMenu {
    ref: HTMLDivElement,
    text: string,
    isNumber: boolean,
    onClick: (value: string) => void
}

const FiltersDropdown = React.forwardRef<HTMLDivElement, DropdownMenu>((props, forwardRef) => {
    const textFilters = ["Contém", "Não contém", "Começa com", "Acaba com", "É igual a", "É diferente de"]
    const numberFilters = ["É igual a", "É diferente de", "É maior que", "É menor que", "É maior/igual que", "É menor/igual que"]

    const allFilters = props.isNumber ? numberFilters : textFilters
    let filteredFilters = [...allFilters]

    // Só filtra se o texto NÃO for uma opção já selecionada (evita mostrar apenas 1 opção)
    if (props.text !== "" && !allFilters.includes(props.text)) {
        filteredFilters = filteredFilters.filter(str => str.toLowerCase().includes(props.text.toLowerCase()))
    }

    return (
        <Container ref={forwardRef}>
            {filteredFilters.map(filters =>
                <FiltersDiv key={filters} onClick={() => props.onClick(filters)}>
                    <FiltersText>{filters}</FiltersText>
                </FiltersDiv>
            )}
        </Container>
    )
})

FiltersDropdown.displayName = "FiltersDropdown";

export default FiltersDropdown